import Base from "antd/lib/typography/Base";
import React, { Fragment, useState } from "react";
import { Animated } from "react-animated-css";
import { Container } from "semantic-ui-react";
import Cards from "../components/CustomCards";
import CustomMenu from "../components/CustomMenu";
import { projects } from "../constants";

/**
 * @author
 * @function Projects
 **/

const Projects = props => {
  const [value,setValue] = useState("Professional")
  const projectsFiltered = projects.filter(proj => proj.type === value)
  const onTabSwitch  = (data) => {
    setValue(data)
  }
  return (
    <Fragment>
      <Base title={"Projects"}>
        <Container>
          <CustomMenu Results={projectsFiltered.length} onTabSwitch={onTabSwitch} />
          {projectsFiltered.map((card, index) => {
            return (
              <>
                <Animated
                  animationIn="fadeInUp"
                  isVisible={true}
                  animationInDelay={200 * index}
                >
                  <Cards item={card} history={props.history}  />
                </Animated>
              </>
            );
          })}
        </Container>
      </Base>
    </Fragment>
  );
};

export default Projects;
